import { PQ_Image_DM_Path, PQ_Image_LM_Path } from "../../../../content/posts/2020-10-22-get-everyone-aligned-with-PQT/images";
import React from 'react';
export default {
  PQ_Image_DM_Path,
  PQ_Image_LM_Path,
  React
};